import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/remote-config'
/* import 'firebase/messaging' */
import firebaseConfig from './config'

firebase.initializeApp(firebaseConfig)
// Utils
const auth = firebase.auth()
const db = firebase.firestore()
/* const messaging = firebase.messaging() */
const storage = firebase.storage()
const { firestore } = firebase
const remoteConfig = firebase.remoteConfig()

const actionCode = {
  url: 'https://hoiwa-app.web.app/apply',
  handleCodeInApp: true,
}

const functions = {
  url: process.env.VUE_APP_FUNCTIONS,
  oiwaUrl: process.env.VUE_APP_FUNCTIONS_OIWA,
}

remoteConfig.defaultConfig = { webAdminClientVersion: 0 }

remoteConfig.settings.minimumFetchIntervalMillis = 60000 // 3600000
remoteConfig.settings.fetchTimeMillis = 2 * 60000

export {
  firebase,
  auth,
  db,
  firestore,
/*   messaging, */
  storage,
  actionCode,
  remoteConfig,
  functions,
}
